import { render } from "./ArtistStatsModal.vue?vue&type=template&id=4f185e37&scoped=true"
import script from "./ArtistStatsModal.vue?vue&type=script&lang=js"
export * from "./ArtistStatsModal.vue?vue&type=script&lang=js"

import "./ArtistStatsModal.vue?vue&type=style&index=0&id=4f185e37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f185e37"]])

export default __exports__